module.exports = __webpack_public_path__ + "img/6bcfba2.png";